import AdminTabs from './view';

export default AdminTabs;
